import React, { FC, useCallback, useState } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,

  SimpleGrid,
  useToast,
  VStack
} from '@chakra-ui/react'
import { yupResolver } from '@hookform/resolvers/yup/dist/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { Input } from '../Form/Input'
import api from '../../Services/api'
import { useAuth } from '../../Hooks/Auth'
import { Loader } from '../Loader'
import { Checkbox } from '../Form/Checkbox'

interface Props {
  isOpen: boolean
  cancelFunction: (data?: any) => void
  nextFunction: (data?: any) => any
  title: string
  description?: string
  cancelText?: string
  nextText?: string
  cancelScheme?: string
  nextScheme?: string
  thirdButton?: boolean
  thirdButtonText?: string
  thirdButtonFunction?: (data?: any) => void
}

const TermsAndCondictionsModal: FC<Props> = ({
  isOpen,
  cancelFunction,
  nextFunction,
  title,
  description,
  cancelText,
  nextText,
  cancelScheme,
  nextScheme,
  thirdButton,
  thirdButtonText,
  thirdButtonFunction
}) => {
  const cancelRef = React.useRef<any>()
  const [loading, setLoading] = useState(false)
  const [termsChecked, setTermsChecked] = useState(false)
  const { register, handleSubmit, formState } = useForm({

  })
  const toast = useToast()
  const { user, updateGlobalUser } = useAuth()

  const { errors } = formState

  const handleSubmitForm: SubmitHandler<any> = useCallback(
    async (values) => {
      setLoading(true)

      try {
        await api.patch('/collaborators/terms')

        await updateGlobalUser({ terms: 1 })
        setLoading(false)

        nextFunction()
      } catch (error) {
        console.log('error: ', error)
        toast({
          title: error?.response?.data?.message,
          position: 'top',
          isClosable: true,
          status: 'error',
          variant: 'solid'
        })
        setLoading(false)
      }
    },
    [nextFunction, toast, updateGlobalUser]
  )

  const handleSelectTerms = useCallback((e: any) => {
    const checked = e?.target?.checked

    if (checked) {
      setTermsChecked(true)
    } else {
      setTermsChecked(false)
    }
  }, [])

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={cancelFunction}
      isCentered
      size={'6xl'}
    >
        {loading && <Loader />}
      <AlertDialogOverlay>
      <Box
          as="form"
            onSubmit={handleSubmit(handleSubmitForm)}

          flex="1"
          p="8"
        >
        <AlertDialogContent bgColor="white">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {title}
          </AlertDialogHeader>

          <AlertDialogBody>
          <iframe src="https://projecto-platform.s3.amazonaws.com/termos-uso.pdf" width="100%" height="600"></iframe>
          </AlertDialogBody>

          <AlertDialogFooter>

          <Checkbox colorScheme="blue" {...register('terms')} onChange={(e: any) => handleSelectTerms(e)} label="Eu aceito os termos de uso" />

            <Button
            type='submit'
              colorScheme={nextScheme || 'blue'}

              ml={3}
              disabled={!termsChecked}
            >
             Continuar
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
        </Box>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export { TermsAndCondictionsModal }
